import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlowMeterReportPageComponent } from './flow-meter-report-page.component';
import {TabModule} from '../../../tab/tab.module';
import {FlowMeterReportToolbarModule} from '../flow-meter-report-toolbar/flow-meter-report-toolbar.module';
import {FlowMeterReportModule} from '../flow-meter-report/flow-meter-report.module';
import {DxDrawerModule, DxListModule, DxLoadPanelModule} from 'devextreme-angular';



@NgModule({
  declarations: [FlowMeterReportPageComponent],
  imports: [
    CommonModule,
    TabModule,
    FlowMeterReportToolbarModule,
    FlowMeterReportModule,
    DxLoadPanelModule,
    DxDrawerModule,
    DxListModule
  ],
  exports: [FlowMeterReportPageComponent]
})
export class FlowMeterReportPageModule { }
